import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e95f1af0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { enctype: "multipart/form-data" }
const _hoisted_2 = { class: "button-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-add" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MailHeader = _resolveComponent("MailHeader")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_SelectMenu = _resolveComponent("SelectMenu")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_AttachmentSelector = _resolveComponent("AttachmentSelector")!
  const _component_MessageLayoutWrapper = _resolveComponent("MessageLayoutWrapper")!
  const _component_EventStateSpinner = _resolveComponent("EventStateSpinner")!
  const _component_TabBar = _resolveComponent("TabBar")!
  const _component_PageWrapper = _resolveComponent("PageWrapper")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createVNode(_component_PageWrapper, {
      contentWidthFull: "",
      contentHeaderRemoveFalseHeaderSpace: "",
      contentBodyBottomMarginDisabled: ""
    }, _createSlots({
      "content-header": _withCtx(() => [
        _createVNode(_component_MailHeader, {
          icon: _ctx.headerIcon,
          "header-text": _ctx.headerText,
          "button-opts": _ctx.headerButtonOpts,
          noBack: !_ctx.$isMobile || !_ctx.replying,
          onBackClick: _ctx.cancelOnBack
        }, null, 8, ["icon", "header-text", "button-opts", "noBack", "onBackClick"])
      ]),
      "fixed-footer": _withCtx(() => [
        _createVNode(_component_TabBar, { "tab-bar-items": _ctx.tabBarItems }, null, 8, ["tab-bar-items"])
      ]),
      _: 2
    }, [
      (!_ctx.isLoading)
        ? {
            name: "content-top",
            fn: _withCtx(() => [
              _createVNode(_component_MessageLayoutWrapper, {
                compose: "",
                "body-header-text": _ctx.messageHeaderText,
                "has-attachments": _ctx.hasAttachments
              }, {
                clinic: _withCtx(() => [
                  (_ctx.$isMobile)
                    ? (_openBlock(), _createBlock(_component_BaseButton, {
                        key: 0,
                        pattern: _ctx.ButtonColorPattern.TRANSPARENT,
                        color: _ctx.clinicSelectColour,
                        disabled: _ctx.replying || _ctx.clinicOptions.length === 0 || _ctx.isLoading,
                        onClick: _ctx.presentClinicPicker
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createTextVNode(_toDisplayString(_ctx.selectClinicText) + " ", 1),
                            _hoisted_3
                          ])
                        ]),
                        _: 1
                      }, 8, ["pattern", "color", "disabled", "onClick"]))
                    : (_openBlock(), _createBlock(_component_SelectMenu, {
                        key: 1,
                        hideLabel: "",
                        options: _ctx.clinicOptions,
                        "z-index": 10,
                        placeholder: _ctx.selectClinicText,
                        "no-select": _ctx.clinicOptions.length === 0 ? this.$mhat('MessageCompose.NoClinicsAvailableMessage') : null,
                        disabled: _ctx.replying || _ctx.clinicOptions.length === 0 || _ctx.isLoading,
                        selected: _ctx.selectedClinic,
                        onSelection: _cache[0] || (_cache[0] = (clinic) => _ctx.selectRecipient(clinic))
                      }, null, 8, ["options", "placeholder", "no-select", "disabled", "selected"]))
                ]),
                subject: _withCtx(() => [
                  _createVNode(_component_TextField, {
                    id: "subject",
                    placeholder: this.$mhat('MessageCompose.SubjectPlaceholderText'),
                    hideLabel: "",
                    value: _ctx.message.subject,
                    disabled: _ctx.replying,
                    onInput: _cache[1] || (_cache[1] = (input) => _ctx.message.subject = input.value)
                  }, null, 8, ["placeholder", "value", "disabled"])
                ]),
                body: _withCtx(() => [
                  _createVNode(_component_TextArea, {
                    id: "body",
                    placeholder: this.$mhat('MessageCompose.MessagePlaceholderText'),
                    hideLabel: "",
                    "auto-grow": "",
                    value: _ctx.message.body,
                    rows: 8,
                    onInput: _cache[2] || (_cache[2] = (input) => _ctx.message.body = input.value)
                  }, null, 8, ["placeholder", "value"])
                ]),
                attachments: _withCtx(() => [
                  _createVNode(_component_AttachmentSelector, {
                    ref: "attachmentSelector",
                    onChange: _ctx.onAttachmentsChanged,
                    accept: _ctx.allowedAttachmentFileExtensions
                  }, null, 8, ["onChange", "accept"])
                ]),
                _: 1
              }, 8, ["body-header-text", "has-attachments"])
            ])
          }
        : undefined,
      (_ctx.isLoading)
        ? {
            name: "content-center",
            fn: _withCtx(() => [
              _createVNode(_component_EventStateSpinner, {
                "is-loading": _ctx.isLoading,
                "loading-icon": "icon-chat",
                "loading-title": this.$mhat('MessageCompose.LoadingTitle')
              }, null, 8, ["is-loading", "loading-title"])
            ])
          }
        : undefined
    ]), 1024)
  ]))
}